import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './api';

export interface NotificationSettingsResponse {
  firebaseUid: string;
  userRole: string;
  settings: Record<string, boolean>;
}

export interface UpdateNotificationSettingsRequest {
  settings: Record<string, boolean>;
}

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['NotificationSettings'],
  endpoints: (builder) => ({
    getNotificationSettings: builder.query<NotificationSettingsResponse, void>({
      query: () => '/notifications/settings',
      providesTags: ['NotificationSettings'],
    }),
    updateNotificationSettings: builder.mutation<NotificationSettingsResponse, UpdateNotificationSettingsRequest>({
      query: (body) => ({
        url: '/notifications/settings',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['NotificationSettings'],
    }),
  }),
});

export const {
  useGetNotificationSettingsQuery,
  useUpdateNotificationSettingsMutation,
} = notificationApi;
